export default "__VITE_ASSET__B48HYnt0__"